import { getBEDEV2ServiceBasePath } from '@modules/utilities/constants/baseUrl';
import { Configuration } from '@rbx/clients';
import { ChannelApi, DocumentationApi, VoteType } from '@rbx/clients/feedbackGatewayApi';
import { FeedbackRating } from '@rbx/conv-ai-provider';

const FEEDBACK_CHANNEL_ID = 'documentation';

type TextLengthRules = { min: number; max: number };

export type FeedbackPermissions = {
  isDocsFeedbackAllowed: boolean;
  isPublicDevForumFeedbackAllowed: boolean;
  descriptionLength: TextLengthRules;
  titleLength: TextLengthRules;
};

class CreatorFeedbackClient {
  private channelApi: ChannelApi;

  private docsFeedbackApi: DocumentationApi;

  constructor(basePath: string = getBEDEV2ServiceBasePath('feedback')) {
    const defaultConfig = new Configuration({
      basePath,
      credentials: 'include',
    });

    this.channelApi = new ChannelApi(defaultConfig);
    this.docsFeedbackApi = new DocumentationApi(defaultConfig);
  }

  async getConfig(): Promise<FeedbackPermissions> {
    const { channel: data } = await this.channelApi.channelGetChannel({
      channelId: FEEDBACK_CHANNEL_ID,
    });
    return {
      isDocsFeedbackAllowed: data.canCreateIssues,
      isPublicDevForumFeedbackAllowed: data.canCreatePublicIssues,
      descriptionLength: {
        min: data.descriptionMinLength,
        max: data.descriptionMaxLength,
      },
      titleLength: {
        min: data.titleMinLength,
        max: data.titleMaxLength,
      },
    };
  }

  async createIssue({
    pageTitle,
    titleLength,
    ratingValue,
    comment,
    isPublic,
  }: {
    pageTitle: string;
    titleLength: TextLengthRules;
    ratingValue: FeedbackRating;
    comment?: string;
    isPublic: boolean; // to post on dev forum publicly
  }) {
    let title = `Feedback on "${pageTitle.trim()}"`.slice(0, titleLength.max);
    if (title.length < titleLength.min)
      title += Array(titleLength.min - title.length)
        .fill(' ')
        .join('');
    const documentationCreateDocumentationIssueRequest = {
      title,
      description: comment ?? '',
      url: window.location.href,
      voteType: ratingValue === FeedbackRating.Positive ? VoteType.Helpful : VoteType.NotHelpful,
      isPublic,
    };
    const resp = await this.docsFeedbackApi.documentationCreateDocumentationIssue({
      documentationCreateDocumentationIssueRequest,
    });
    return resp;
  }
}

export default new CreatorFeedbackClient();
